// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__19PPO","title":"AfterFrontImage_title__1vcjA"};